import { useRef } from 'react';
import { attachMessages } from '../i18n';
import { useIntl } from 'react-intl';
import { Item } from './Item';
import { IAttachItemProps } from '../../types';
import { DocumentIcon } from 'src/components/Icons/DocumentIcon';

export const AttachDoc = ({ onSelect }: IAttachItemProps) => {
	const documentInputRef = useRef<HTMLInputElement>(null);
	const intl = useIntl();
	const documentText = intl.formatMessage(attachMessages.document);

	return (
		<Item
			icon={<DocumentIcon />}
			text={documentText}
			className="document"
			onClick={() => documentInputRef.current?.click()}
		>
			<input type="file" hidden ref={documentInputRef} onChange={onSelect} />
		</Item>
	);
};
